<div class="inner-content" ridangoAppTrapFocus>
    <div class="flex-column flex h-full rounded-2xl bg-white text-base">
        <div class="flex-align-center !flex justify-between border-b border-solid border-solid p-4">
            <p></p>
            <p class="font-semibold">{{ 'SELECT_COUNTRY_PREFIX_LABEL' | translate }}</p>
            <button [attr.aria-label]="'CLOSE_ARIA_LABEL' | translate" (click)="cancel()" mat-icon-button>
                <mat-icon class="close-button font-bold">close</mat-icon>
            </button>
        </div>

        <div class="flex-1 overflow-y-auto overflow-x-hidden">
            <mat-radio-group class="vertical-radio-group">
                <ng-container *ngFor="let code of availableCountryCallingCodes">
                    <div class="mx-4 py-4">
                        <mat-radio-button
                            class="vertical-radio-button"
                            [value]="code"
                            [checked]="selectedCode === code"
                            (change)="handleCountryChange(code)">
                            <p class="word-break overflow-x-hidden text-ellipsis">
                                {{ 'COUNTRY_NAME_BY_CALLING_CODE_' + code?.replace('+', '') | translate }}
                                ({{ code }})
                            </p>
                        </mat-radio-button>
                    </div>
                    <mat-divider></mat-divider>
                </ng-container>
            </mat-radio-group>
        </div>
        <div class="m-4">
            <button
                class="select-button sr-app-light:text-white sr-app-light:h-16 h-14 w-full rounded-lg font-bold dark:bg-contrast-yellow dark:text-contrast-black"
                (click)="handleSaveClick()">
                {{ 'SELECT_LABEL' | translate }}
            </button>
        </div>
    </div>
</div>
